import styled from 'styled-components';
import { Body } from 'syf-component-library/ui/typography/';
import { colors, fontSizes, fontWeights } from 'syf-component-library/defaultTheme';
export const CustomContainer = styled.div `
  background-color: ${colors.turquoiseLightest};
  border-radius: 10px;
  width: 100%;
`;
export const TextContainer = styled.div `
  text-align: center;
`;
export const Title = styled(Body) `
  font-weight: ${fontWeights.bold};
  font-size: 36px;
`;
export const NormalText = styled(Body) `
  font-size: ${fontSizes.root}px;
`;
